<!-- 组件 - 例句翻译 -->
<template>
    <div>
        <el-form class="sentence-form" ref="form" label-width="80px">
            <!-- data -->
            <div class="data">
                <div>
                    <!-- show data -->
                    <div v-for="(item, key) in sentences">
                        <el-form-item style="margin-bottom:12px;" class="sentence-item">
                            <el-radio v-model="data.sentence.id" :label="item.id">{{item.text}}</el-radio>
                        </el-form-item>
                    </div>
                </div>
            </div>
            <!-- attributes -->
            <el-tabs type="border-card">
                <el-tab-pane>
                    <span slot="label"><i class="el-icon-suitcase-1"></i> 属性</span>
                    <div class="attribute" v-for="(component, index) in attributes">
                        <component :is="component.type" v-model="attributes[index]"></component>
                    </div>
                </el-tab-pane>
            </el-tabs>
            <div class="actions">
                <el-button type="primary" @click="submit">确 定</el-button>
            </div>
        </el-form>
    </div>
</template>
<script>
import Size from './attribute/Size.vue'
import Align from './attribute/Align.vue'
export default {
    name: 'SentenceTranslation',
    components: {
        Size,
        Align,
    },
    props: {
        value: Object,
        sign: String,
        archive: Object,
    },
    data() {
        return {
            has: false,
            sentences: [],
            detail: null,
            data: {
                sentence: {
                    id: null
                }
            },
            attributes: [],
            availableAttributes: [
                { type: 'Align', checked: false, value: null },
                { type: 'Size', checked: false, value: null },
            ],
        }
    },
    watch: {
        attributes(newVal, oldVal) {},
        data(newVal, oldVal) {},
        sign(newVal, oldVal) {
            this.init()
        },
    },
    created() {},
    mounted() {
        this.init()
    },
    methods: {
        init() {
            this.detail = this.value
            this.data = this.detail.data
            this.attributes = this.detail.attributes
            this.initData()
            this.initAttributes()
            this.initSentences()
        },
        // 初始化例句
        initSentences() {
            for (var i in this.archive.details) {
                var detail = this.archive.details[i]
                if (detail.type == 'Sentence' && detail.data != null) {
                    this.sentences.push(detail.data.sentence)
                    if (detail.data.sentence.id == this.data.sentence.id) {
                        this.has = true
                    }
                }
            }
            if (this.has == false && this.data.sentence.id != null) {
                this.sentences.push(this.data.sentence)
            }
        },
        // 初始化数据
        initData() {
            if (this.data == null) {
                this.data = {
                    sentence: {
                        id: null
                    }
                }
            }
        },
        // 初始化属性
        initAttributes() {
            for (var j in this.availableAttributes) {
                var b = this.availableAttributes[j]
                for (var i in this.attributes) {
                    var a = this.attributes[i]
                    if (b.type == a.type) {
                        b.checked = a.checked
                        b.value = a.value
                    }
                }
            }
            this.attributes = this.availableAttributes
        },
        // 保存属性:新增,修改,删除
        saveAttr(data, type) {
            if (this.attributes.length == 0) {
                this.attributes.push(data)
                return true
            }
            var matched = false
            for (var i in this.attributes) {
                if (this.attributes[i].type == type) {
                    matched = true
                    if (data == null) {
                        this.attributes.splice(i, 1)
                        break
                    }
                    this.attributes[i] = data
                }
            }
            if (matched == false) {
                this.attributes.push(data)
            }
        },
        mergeData() {
            if (this.data.sentence.id != null) {
                this.detail.data = this.data
            }
            this.detail.attributes = this.attributes
        },
        submit() {
            this.mergeData()
            this.$emit('input', this.detail)
            this.close()
        },
        close() {
            this.$emit('closeComponent')
        },
        closeSearchBox() {
            this.showSearchBox = false
        },
    },
}
</script>
<style lang="scss">
.attribute {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #f5f5f5;

    &:last-child {
        border-bottom: 0px;
    }

    .checkbox {
        margin-top: -12px;
    }
}

.sentence-item {
    display: flex;
    align-items: center;

    .sentence {
        margin-left: 10px;

    }
}
</style>